module.exports = __webpack_public_path__ + "img/saveWhatsAppStatus.74c31cfd.webp";